/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorAffiliateItem from 'base/components/labrador/AffiliateItem';

export const DynamicLabradorAffiliateItem: typeof LabradorAffiliateItem = (props) => {
    return <ErrorBoundary><LabradorAffiliateItem {...props} /></ErrorBoundary>;
}
export type DynamicLabradorAffiliateItemProps = PropsFromComponent<typeof LabradorAffiliateItem>;
